export const track = (body) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer?.push(body);
};

export const trackFB = (event, body) => {
  window.fbq && window.fbq('track', event, body);
};
